import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { WaitListEntry } from '../models/WaitListEntry';
import { Router } from '@angular/router';
import * as qs from 'qs';
@Injectable({
  providedIn: 'root',
})
export class SessionService {

  public code = '';
  token = '';
  waitList: WaitListEntry | undefined;
  waitListId = '';
  lang = 'English';
  constructor(private api: ApiService, private router: Router) {}

   parseQueryParams() {
    const queryString = this.router.url.split("?")[1] || "";
    if (!queryString) {
      return {};
    }

    return qs.parse(queryString, {
      ignoreQueryPrefix: true,
      depth: 5,
      allowDots: false
    });
  };

  init(code: string) {
    this.code = code;
    const parsed = this.parseQueryParams();
    const last4 = parsed['last4'] as string;
    if (last4) {
      this.api.claimWaitListEntryWithCode(this.code, last4).subscribe(
        (data) => {
          // this.router.navigateByUrl(`/q/${this.code}?token=${data.token || ''}`);
          if (
            data.status == 'success' &&
            data.waitlistEntry &&
            data.waitlistEntry.status == 'QUEUED' &&
            (!data.waitlistEntry.guest || !data.waitlistEntry.guest.firstName)
          ) {
            data.waitlistEntry.status = 'CLAIMED';
          }
          console.log('Data', data);
          this.setData(data);
          this.formatMobile();
        },
        (error) => {
          console.log(error);
          this.router.navigateByUrl(`/code/${this.code}`);
        }
      );
      return;
    }

    this.token = localStorage.getItem('code-' + this.code) || '';
    let tk = ''
    let arr = this.router.url.split('?token=');
    if(arr.length>1){
      tk = arr[1]
    }
    this.token = localStorage.getItem('code-' + this.code) || tk || '';
    this.waitListId = localStorage.getItem('code-' + this.code + '-wait') || '';
    if (this.token.length > 0) {
      this.api.getWaitListEntry(this.token).subscribe(
        (data) => {
          if (
            data.status == 'success' &&
            data.waitlistEntry &&
            data.waitlistEntry.status == 'QUEUED' &&
            (!data.waitlistEntry.guest || !data.waitlistEntry.guest.firstName)
          ) {
            data.waitlistEntry.status = 'CLAIMED';
          }
          this.waitList = data.waitlistEntry;
          console.log('Data', data);
          this.formatMobile();
        },
        (error) => {
          console.log('Error', error);
        }
      );
    } else {
      // token is not in memory request a new one
      this.api.claimWaitListEntry(this.code).subscribe(data => {
        if (data.status === 'success'){
          this.setData(data);
        }
      }, error => {
        console.log('Error while claiming!', error.status, error);
        if (error.status === 400){
          this.router.navigateByUrl(`/code/${this.code}`)
        }
      });
    }
  }

  formatMobile(): void{
    if (this.waitList?.guest){
      const mobile = this.waitList?.guest.mobileNumber.replace(/.(?=.{4})/g, '*');
      this.waitList.guest.mobileNumber = mobile || '';
    }
  }

  public setData(data: any) {
    if (data.status == 'success' && data.waitlistEntry && data.waitlistEntry.status == 'QUEUED' && (!data.waitlistEntry.guest || !data.waitlistEntry.guest.firstName)) {
      data.waitlistEntry.status = 'CLAIMED';
    }
    this.token = data.token;
    localStorage.setItem('code-' + this.code, this.token);
    this.waitListId = data.waitlistEntry._id;
    this.waitList = data.waitlistEntry;
    localStorage.setItem('code-' + this.code + '-wait', data.waitlistEntry._id);
  }
}
